import React, { useEffect, useState } from 'react';
import { cn } from '@app/shared/utils/common';
import { Paragraph, ShareButton } from '@app/shared/ui/atoms/Common';
import { cakeLeftIcon, cakeRightIcon } from '@app/assets';

interface CookieFeedAnimationProps {
  cookie: { text: string | null; image: string | null };
}

export function PredictionCookieReveal({ cookie }: CookieFeedAnimationProps) {
  const [visibleCookie, setVisibleCookie] = useState<CookieFeedAnimationProps['cookie']>({
    text: null,
    image: null,
  });
  const [isAnimationFinished, setIsAnimationFinished] = useState(false);

  useEffect(() => {
    if (cookie.text) {
      setIsAnimationFinished(false);
      const timer = setTimeout(() => {
        setVisibleCookie(cookie);
      }, 30);

      return () => {
        clearTimeout(timer);
      };
    }
  }, [cookie]);

  const handleTransitionEnd = (e: React.TransitionEvent) => {
    if (e.propertyName === 'opacity') {
      setIsAnimationFinished(true);
    }
  };

  return (
    <div>
      <div className="relative flex items-center justify-center cursor-pointer">
        <img
          src={cakeLeftIcon}
          alt="cake left"
          className={cn(
            'relative left-12 z-10 size-[100px] -rotate-12 transition-all duration-800',
            visibleCookie.text && '-left-[24%]'
          )}
        />

        <Paragraph
          onTransitionEnd={handleTransitionEnd}
          className={cn(
            'absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 wrap-break-word text-center text-foreground opacity-0 transition-all duration-0',
            visibleCookie.text && 'opacity-100 duration-800'
          )}
        >
          {visibleCookie.text}
        </Paragraph>

        <img
          src={cakeRightIcon}
          alt="cake right"
          className={cn(
            'relative -left-[30px] top-[6px] z-10 size-[130px] rotate-12 transition-all duration-800',
            visibleCookie.text && 'left-[28%]'
          )}
        />
      </div>
      <ShareButton
        cookie={visibleCookie}
        className={cn(
          'opacity-0 pointer-events-none transition-opacity duration-300',
          isAnimationFinished && 'opacity-100 pointer-events-auto'
        )}
      />
    </div>
  );
}
